import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06e2fbf1")

_pushScopeId("data-v-06e2fbf1")
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "link" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_copyright = _resolveComponent("copyright")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.linksRoutes, (route, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          to: { name: route.name },
          key: index
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(route.meta.title), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _createVNode(_component_copyright)
  ]))
})